import PrivateNetworkClient from "helpers/privateNetwork";

const departmentList = async (formData) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.post("/getDepartmentList", formData);
  return data;
};

const addDepartment = async (formData) => {
  const { data } = await PrivateNetworkClient.post("/addDepartment", formData);
  return data;
};

const editDepartment = async (formData) => {
  const { data } = await PrivateNetworkClient.put("/editDepartment", formData);
  return data;
};

const deleteDepartment = async (id) => {
  const { data } = await PrivateNetworkClient.delete(`/deleteDepartment/${id}`);
  return data;
};

const changeStatus = async (id) => {
  const { data } = await PrivateNetworkClient.put(`/changeStatus/${id}`);
  return data;
}
export {
  departmentList,
  addDepartment,
  editDepartment,
  deleteDepartment,
  changeStatus
};
